import { z } from 'zod';

export const systemFilterSchema = z.object({
	geofenceId: z
		.array(
			z.object({
				value: z.number().nullable(),
				label: z.string().optional(),
			})
		)
		.nullable()
		.optional()
		.transform((value) => value?.map((item) => item.value).join(',')),
});

export type SystemFilterSchemaType = z.infer<typeof systemFilterSchema>;
